const ImageWithText = function() {
    function ImageWithText() {
        this.selector = {
            container: document.querySelectorAll(".render-image-with-text__media")
        }
        this.load();
    }
    ImageWithText.prototype.load = function() {
        var _ = this;
        let loaded = false;
        window.addEventListener("scroll", function() {
            if(_.selector.container.length > 0 && !loaded && window.scrollY > 10) {
                _.selector.container.forEach(el => {
                    el.innerHTML = el.dataset.content;
                })
                loaded = true;
            }
        })
    }
    ImageWithText = new ImageWithText;
}
ImageWithText();